import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CommonUtil } from "app/utils/common.util";
import { UrlUtil } from "app/utils/url.util";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class LocationService {
  constructor(
    private http: HttpClient,
    private urlUtil: UrlUtil,
    private commonUtil: CommonUtil,
    private _translateService: TranslateService
  ) {}

  public getLocationList() {
    return this.http
      .get(this.urlUtil.getUrl("location", "getAll").replace("$ORGANIASTION_ID", this.commonUtil.getUserDetail("organisationId")))
      .pipe(
        map((response: any) => {
          if (response && response?.length) {
            return response;
          } else {
            return [];
          }
        }),
        catchError((e) => {
          console.log("getLocationList error =>", e);
          return of([]);
        })
      );
  }

  public saveLocation(data) {
    return this.http.post(this.urlUtil.getUrl("location", "save"), data).pipe(
      map((response: any) => {
        const { status, jsonData, errorMessage } = response;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataSaveSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataSave")
          };
        }
      }),
      catchError((e) => {
        console.log("save location error =>", e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataSave")
        });
      })
    );
  }

  public deleteLocation(id: string) {
    return this.http.delete(this.urlUtil.getUrl("location", "delete").replace("$ID", id)).pipe(
      map((response: any) => {
        const { status, jsonData, errorMessage, data } = response;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataDeleteSuccess"),
            data: null
          };
        }
        return {
          status: false,
          message: errorMessage || jsonData || this._translateService.instant("FailDataDelete"),
          data: null
        };
      }),
      catchError((e) => {
        console.log("delete location error =>", e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataDelete")
        });
      })
    );
  }
}
